import * as SettingsActions from "./settingsActions";

export default SettingsActions;
